import axios from 'axios';
import { ApiConfig } from '../../Config'



var UpdateEmailCtrl = function (fn, er, state) {
    
    var config = {
        headers: {
            'MT_SESSION_ID': sessionStorage.getItem('ids'),
            'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            'Content-Type': 'application/json',
        }
    }

    var data = {
        email: state.newMail
    }

    axios
        .post(ApiConfig.url.UPDATE_MAIL, data, config)
        .then((result) => {
            fn(result, result.status)
        }).catch((error) => {
            er(error !== undefined && error.response !== undefined && error.response.status !== undefined ? error.response.status : 500,
               error !== undefined && error.response !== undefined && error.response.data !== undefined && error.response.data.details ? error.response.data.details[0] : 500)
        });
}
export { UpdateEmailCtrl }